import React, {Fragment, useEffect, useState} from "react";
import "./NewTabulator1.scss";
import CellValue from "./CellValue";
import {
  formatToPersianAddComma, parseToEnRemoveComma,
} from "../../utils/CommaSeparator";
import {v4 as uuidv4} from "uuid";
import PaginationSection from "./PaginationSection";
import objectDataHolder from "../Hooks/ObjectDataHolder";

const NewTabulator1 = (props) => {
  let {columns, data, events} = props;

  if (!columns) columns = [];
  if (!data) data = [];

  const [selectedRow: {}, setSelectedRow] = useState({});

  const myColumns: string[] = [...columns];
  const myData: any[] = [...data];

  let titles: any[] = [];
  let fields: any[] = [];
  let editors: any[] = [];
  let bottomCalcs: any[] = [];
  let bottomCalcValues: any[] = [];
  let formatters: any[] = [];
  let visibles: any[] = [];
  let cellClicks: any[] = [];
  let cellEditeds: any[] = [];
  let maxWidths: any[] = [];
  let styles: any[] = [];
  let hasFilters: any[] = [];
  const [filterValues, setFilterValues] = useState({})

  myColumns.forEach((myColumn, index) => {
    let {
      title, field, visible, editor, bottomCalc, formatter, cellClick, cellEdited, style, hasFilter,
    } = myColumn;

    titles.push(title);
    fields.push(field);
    editors.push(editor);
    bottomCalcs.push(bottomCalc);
    bottomCalcValues.push(0);
    formatters.push(formatter);
    visibles.push(visible);
    cellClicks.push(cellClick);
    cellEditeds.push(cellEdited);
    styles.push(style);
    hasFilters.push(hasFilter);


  });


  const singleRowClick = (singleRowData) => {
    events?.rowClick && setSelectedRow(singleRowData);
    events?.rowClick && events?.rowClick(singleRowData);
  };
  const singleRowDoubleClick = (singleRowData) => {
    events?.rowDoubleClick && events?.rowDoubleClick(singleRowData);
  };

  useEffect(() => {

    if (events?.selectedRow) {
      const key = events.selectedRow ? Object?.keys(events?.selectedRow)[0] : undefined
      const value = events.selectedRow ? Object?.values(events?.selectedRow)[0] : undefined
      let tempSelectedRow;
      events.selectedRow && key && value && myData.forEach((singleRowData, index) => {

        if (singleRowData[key] === value) {
          setSelectedRow(singleRowData)
          tempSelectedRow = singleRowData
        }
      })


      tempSelectedRow && events?.rowClick && events?.rowClick(tempSelectedRow);
    }


  }, [JSON.stringify(events?.selectedRow), JSON.stringify(myData)]);


  const [filteredData, setFilteredData] = useState(myData);
  const [paginatedData, setPaginatedData] = objectDataHolder({
    currentPage: 1,
    data: myData,
    rowsPerPage:events.paginationPageSize || 10,
    totalPages:0,
  })

  useEffect(() => {
    setFilteredData(myData)
    let myFilteredData = [...myData];

    if (Object.keys(filterValues)?.length > 0) {
      for (const filterValuesKey in filterValues) {
        myFilteredData = myFilteredData.filter(v => {

          //debugger
          //console.log(myFilteredData)
          return v[filterValuesKey].includes(filterValues[filterValuesKey])
        })
      }
    }



    setFilteredData(myFilteredData);

    if (events.pagination) {

      let myPaginatedData = []
      let rowsPerPage = paginatedData.rowsPerPage;
      for (let i = 0; i < myFilteredData.length; i = i + rowsPerPage) {
        const singlePage = []
        for (let j = i; j < i + rowsPerPage; j++) {
          myFilteredData[j] && singlePage.push(myFilteredData[j])
        }
        singlePage.length > 0 && myPaginatedData.push(singlePage)
      }
      // در صورتی که خالی بود هم بتونه رندر بشه
      if(myPaginatedData.length===0){
        myPaginatedData.push([])
      }
      setPaginatedData({...paginatedData, data: myPaginatedData , totalPages: myPaginatedData.length})
      console.log(myPaginatedData)

    }


  }, [JSON.stringify(myData), JSON.stringify(filterValues),paginatedData.rowsPerPage])

  useEffect(() => {
    if (events?.onDataChange) {
      if (events.pagination) {
        const currentPageData = paginatedData.data[paginatedData.currentPage - 1] || [];
        events.onDataChange(currentPageData);
      } else {
        events.onDataChange(filteredData);
      }
    }
  }, [JSON.stringify(paginatedData.data), paginatedData.currentPage, JSON.stringify(filteredData)]);


  const filterValuesChangeHandler = (e, field) => {


    const myFilteredValues = {...filterValues};
    myFilteredValues[field] = e.target.value;
    setFilterValues(myFilteredValues)


  }



  try {
    return (<div className={`${props.className} NewTabulator1`}>
      <div {...props} className={"position-relative "}
        // style={{ height:'30vh' , overflow:'scroll'}}
      >
        <ul className={"header__Of__Table"}>
          {myColumns.map((myColumn, index) => {


            return (<React.Fragment key={index}>
              {myColumn.visible !== false && (<li style={styles[index]}>

                <div>{myColumn.title}</div>

                {hasFilters[index] && <div>
                  <input
                    onChange={(e) => filterValuesChangeHandler(e, myColumn.field)}
                    value={filterValues[myColumn.field] ? filterValues[myColumn.field] : ""} className={"w-100"}
                    type="text"/>
                </div>}
              </li>)}
            </React.Fragment>);
          })}
        </ul>
        <>
          {events?.pagination === undefined ? <>
            {filteredData.map((singleRowData, index) => (<React.Fragment key={index}>
              <ul

                className={JSON.stringify(singleRowData) === JSON.stringify(selectedRow) ? "rowSelected" : ""}
                onClick={() => singleRowClick(singleRowData)}
                onDoubleClick={() => singleRowDoubleClick(singleRowData)}
              >
                {fields.map((field, indexField: number) => {
                  const value = singleRowData[field];

                  const editor = editors[indexField];
                  const formatter = formatters[indexField];
                  const cellClick = cellClicks[indexField];
                  const visible = visibles[indexField];
                  const bottomCalc = bottomCalcs[indexField];
                  if (bottomCalc !== undefined) {
                    bottomCalcValues[indexField] += +parseToEnRemoveComma(value);
                    const keys = Object.keys(singleRowData);
                    // bottomCalcValues[keys[indexField]] = +parseToEnRemoveComma(value)
                    bottomCalcValues[keys[indexField]] = +value;
                  }
                  const cellEdited = cellEditeds[indexField];
                  const style = styles[indexField];

                  // NOTE: I must Expand Cell Object WhenEver I need :)
                  let cell = {
                    getData: () => {
                      return singleRowData;
                    }, getValue: () => {
                      return value;
                    },
                  };
                  if (visible === false) {
                    return null;
                  }
                  return (<li
                    key={indexField + "" + index}
                    onClick={cellClick && ((e) => cellClick(e, cell))}
                    style={style}
                  >
                    <CellValue
                      key={uuidv4()}
                      number={indexField}
                      cell={cell}
                      editor={editor}
                      formatter={formatter}
                      bottomCalc={bottomCalc}
                      value={value}
                      cellEdited={cellEdited}
                    />
                  </li>);
                })}
              </ul>

            </React.Fragment>))}
            {events?.ShowAddInLastRow && <ul>{events.ShowAddInLastRow()}</ul>}

            {bottomCalcs?.find(item => item !== undefined) &&
              <ul className={"bottom_Of_Table"} style={{backgroundColor: "#fff"}}>
                {fields.map((field, indexField) => {
                  const bottomCalc = bottomCalcs[indexField];
                  const formatter = formatters[indexField];

                  const visible = visibles[indexField];
                  if (visible === false) {
                    return null;
                  }

                  const value = bottomCalcValues[indexField]
                  let cell = {
                    getData: () => {
                      return bottomCalc;
                    }, getValue: () => {
                      return value;
                    },
                  };
                  return (<li style={styles[indexField]} key={indexField}>
                    {/*{bottomCalc && bottomCalcValues[indexField]}*/}
                    {/*{bottomCalc && formatToPersianAddComma(bottomCalcValues[indexField])}*/}
                    {bottomCalc && <>
                      <CellValue
                        number={indexField}
                        cell={cell}
                        editor={editors[indexField]}
                        formatter={formatter}
                        // bottomCalc={bottomCalc}
                        value={bottomCalc}
                        // cellEdited={cellEdited}
                      />
                    </>}
                  </li>);
                })}
              </ul>}
          </> : <>
            {paginatedData.data[paginatedData.currentPage-1].map((singleRowData, index) => (<React.Fragment key={index}>
              <ul

                className={JSON.stringify(singleRowData) === JSON.stringify(selectedRow) ? "rowSelected" : ""}
                onClick={() => singleRowClick(singleRowData)}
                onDoubleClick={() => singleRowDoubleClick(singleRowData)}
              >
                {fields.map((field, indexField: number) => {
                  const value = singleRowData[field];

                  const editor = editors[indexField];
                  const formatter = formatters[indexField];
                  const cellClick = cellClicks[indexField];
                  const visible = visibles[indexField];
                  const bottomCalc = bottomCalcs[indexField];
                  if (bottomCalc !== undefined) {
                    bottomCalcValues[indexField] += +parseToEnRemoveComma(value);
                    const keys = Object.keys(singleRowData);
                    // bottomCalcValues[keys[indexField]] = +parseToEnRemoveComma(value)
                    bottomCalcValues[keys[indexField]] = +value;
                  }
                  const cellEdited = cellEditeds[indexField];
                  const style = styles[indexField];

                  // NOTE: I must Expand Cell Object WhenEver I need :)
                  let cell = {
                    getData: () => {
                      return singleRowData;
                    }, getValue: () => {
                      return value;
                    },
                  };
                  if (visible === false) {
                    return null;
                  }
                  return (<li
                    key={indexField + "" + index}
                    onClick={cellClick && ((e) => cellClick(e, cell))}
                    style={style}
                  >
                    <CellValue
                      key={uuidv4()}
                      number={indexField}
                      cell={cell}
                      editor={editor}
                      formatter={formatter}
                      bottomCalc={bottomCalc}
                      value={value}
                      cellEdited={cellEdited}
                    />
                  </li>);
                })}
              </ul>

            </React.Fragment>))}
            {events?.ShowAddInLastRow && <ul>{events.ShowAddInLastRow()}</ul>}

            {bottomCalcs?.find(item => item !== undefined) &&
              <ul className={"bottom_Of_Table"} style={{backgroundColor: "#fff"}}>
                {fields.map((field, indexField) => {
                  const bottomCalc = bottomCalcs[indexField];
                  const formatter = formatters[indexField];

                  const visible = visibles[indexField];
                  if (visible === false) {
                    return null;
                  }

                  const value = bottomCalcValues[indexField]
                  let cell = {
                    getData: () => {
                      return bottomCalc;
                    }, getValue: () => {
                      return value;
                    },
                  };
                  return (<li style={styles[indexField]} key={indexField}>
                    {/*{bottomCalc && bottomCalcValues[indexField]}*/}
                    {/*{bottomCalc && formatToPersianAddComma(bottomCalcValues[indexField])}*/}
                    {bottomCalc && <>
                      <CellValue
                        number={indexField}
                        cell={cell}
                        editor={editors[indexField]}
                        formatter={formatter}
                        // bottomCalc={bottomCalc}
                        value={bottomCalc}
                        // cellEdited={cellEdited}
                      />
                    </>}
                  </li>);
                })}
              </ul>}
          </>}
        </>
      </div>
      {events?.pagination && <PaginationSection currentPage={paginatedData.currentPage} setPaginatedData={setPaginatedData}
                                                paginatedData={paginatedData}
                                                myData={myData}

      />}

    </div>);
  } catch (error) {
    return <>{error.toString()}</>
  }

};

export default React.memo(NewTabulator1);
